/**
 * BPMN Modeling that uses SafeMoveShapeHandler instead of the default MoveShapeHandler.
 * Fixes "Cannot read properties of null (reading 'children')" when dropping pools from the palette.
 */
import inherits from 'inherits-browser';
import BpmnModeling from 'bpmn-js/lib/features/modeling/Modeling';
import SafeMoveShapeHandler from './SafeMoveShapeHandler';

function SafeModeling(
  this: any,
  eventBus: any,
  elementFactory: any,
  commandStack: any,
  bpmnRules: any
) {
  BpmnModeling.call(this, eventBus, elementFactory, commandStack, bpmnRules);
}

(SafeModeling as any).$inject = ['eventBus', 'elementFactory', 'commandStack', 'bpmnRules'];
inherits(SafeModeling, BpmnModeling);

SafeModeling.prototype.getHandlers = function () {
  const handlers = (BpmnModeling.prototype as any).getHandlers.call(this);
  handlers['shape.move'] = SafeMoveShapeHandler;
  return handlers;
};

export default SafeModeling;
